module.exports = __webpack_public_path__ + "static/img/logox.48b9924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logox.png
// module id = NG8F
// module chunks = 12